module.exports = __webpack_public_path__ + "static/img/realease-landing.0e2c110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/realease-landing.png
// module id = 145
// module chunks = 0